import React, {  useContext, useState } from 'react';
import TodoContext from '../../Context/Todo';
import { Input } from 'reactstrap';
import { AddTask } from '../../Constant';

const AddTodo = () => {
  const { addNewTodo } = useContext(TodoContext);
  const [task, setTask] = useState('');

  const addNewTask = () => {
      if (task === '') {
          return;
      }
      else {
          addNewTodo(task);
          setTask('');
      }
  };
  const onTaskChanged = (e) => {
      setTask(e.currentTarget.value);
  };
  return (
    <>
      <div className="todo-list-header">
                <div className="new-task-wrapper input-group">
                    <Input  id="new-task" value={task} placeholder="Enter new task here. . ." onChange={onTaskChanged} />
                    <span className="btn btn-primary add-new-task-btn" id="add-task" onClick={() => { addNewTask() }}>{AddTask}</span>
                </div>
            </div>

    </>
  );
};
export default AddTodo;
